import setCurrentPage from "src/Utils/setCurrentPage";
import setPreviousPage from "src/Utils/setPreviousPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "boxWithLock",
    iconColor: "white",
    text: "One-stop automation \nfor all networks",
    listItemCustomStyle: { width: "314px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithLight",
    iconColor: "white",
    text: "AI-powered design \nwith large language \nmodels",
    listItemCustomStyle: { width: "296px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "computerWithMapAndLittleBox",
    iconColor: "white",
    text: "Interactive map UI with \nintuitive topology \nvisualization",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "cloudWithMachine",
    iconColor: "white",
    text: "Cloud-native, modular \nand scalable",
    listItemCustomStyle: { width: "307px", marginTop: "67px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "gearsWithArrows",
    iconColor: "white",
    text: "Digital Twin for rapid \nnetwork deployment",
    listItemCustomStyle: { width: "307px", marginTop: "67px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_INLCM_5 = {
  title: "Unveiling Our Standout Features",
  text: "",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  styleListData: { width: "1130px" },
  rightImage: "ENG/INLCM/INLCM_INTRO_06_right_image.png",
  rightImageStyle: { position: "absolute", right: "99.94px", bottom: "379px" },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_305"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_INTRO_06.jpg",
  demoButtons: [
    {
      label: "DIGITAL n/w twin",
      onClick: () => {
        setPreviousPage("ENG_306");
        setCurrentPage("ENG_310");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Gen AI Powered Design",
      onClick: () => {
        setPreviousPage("ENG_306");
        setCurrentPage("ENG_307");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Access Network Rollout",
      onClick: () => {
        setPreviousPage("ENG_306");
        setCurrentPage("ENG_315");
      },
      endIcon: "arrow-right",
    },
    {
      label: "Transport Network",
      onClick: () => {
        setPreviousPage("ENG_306");
        setCurrentPage("ENG_322");
      },
      endIcon: "arrow-right",
    },
  ],
  modalImages: ["ENG/INLCM/modal/INLCM_MODAL_features.png"],
};
